module.exports = __webpack_public_path__ + "media/images/landing/cureus_seal-0c2152f78f87e55c7033574769532b38.png";